import { useEffect } from 'react';
import { useContextState, useContextDispatch } from '../../components/context';

const useDownloadHandler = () => {
  const { downloadLink } = useContextState();
  const { downloadActionClear } = useContextDispatch();

  useEffect(() => {
    if (downloadLink === null) return;

    const filename = downloadLink.replace(/^.*(\\|\/|:)/, '');
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = downloadLink;
    tempLink.setAttribute('download', filename);
    document.body.appendChild(tempLink);
    tempLink.click();

    document.body.removeChild(tempLink);
    downloadActionClear();
  }, [downloadLink]);

  return null;
};

export default useDownloadHandler;
